export const DEFAULT_ALTITUE: number = 9200;
export const DECIMAL_RADIX: number = 10;
export const ALLOWED_URL_SCHEMES: RegExp = /^(https?:|blob:|data:image\/(?!svg))/i;
